export const placesOfService = [
  { label: "01 - Pharmacy", value: "PHARMACY" },
  {
    label: "02 - Telehealth Provided Other than in Patient's Home",
    value: "TELEHEALTH_OUTSIDE_PATIENT_HOME",
  },
  { label: "03 - School", value: "SCHOOL" },
  { label: "04 - Homeless Shelter", value: "HOMELESS_SHELTER" },
  {
    label: "05 - Indian Health Service Free-standing Facility",
    value: "INDIAN_HEALTH_SERVICE_FREE_STANDING_FACILITY",
  },
  {
    label: "06 - Indian Health Service Provider-based Facility",
    value: "INDIAN_HEALTH_SERVICE_PROVIDER_BASED_FACILITY",
  },
  {
    label: "07 - Tribal 638 Free-standing Facility",
    value: "TRIBAL_638_FREE_STANDING_FACILITY",
  },
  {
    label: "08 - Tribal 638 Provider-based Facility",
    value: "TRIBAL_638_PROVIDER_BASED_FACILITY",
  },
  {
    label: "09 - Prison/Correctional Facility",
    value: "PRISON_CORRECTIONAL_FACILITY",
  },
  {
    label: "10 - Telehealth Provided in Patient's Home",
    value: "TELEHEALTH_INSIDE_PATIENT_HOME",
  },
  { label: "11 - Office", value: "OFFICE" },
  { label: "12 - Home", value: "HOME" },
  { label: "13 - Assisted Living Facility", value: "ASSISTED_LIVING_FACILITY" },
  { label: "14 - Group Home", value: "GROUP_HOME" },
  { label: "15 - Mobile Unit", value: "MOBILE_UNIT" },
  { label: "16 - Temporary Lodging", value: "TEMPORARY_LODGING" },
  {
    label: "17 - Walk-in Retail Health Clinic",
    value: "WALK_IN_RETAIL_HEALTH_CLINIC",
  },
  {
    label: "18 - Place of Employment-Worksite",
    value: "PLACE_OF_EMPLOYMENT_WORKSITE",
  },
  {
    label: "19 - Off Campus-Outpatient Hospital",
    value: "OFF_CAMPUS_OUTPATIENT_HOSPITAL",
  },
  { label: "20 - Urgent Care Facility", value: "URGENT_CARE_FACILITY" },
  { label: "21 - Inpatient Hospital", value: "INPATIENT_HOSPITAL" },
  { label: "22 - Outpatient Hospital", value: "OUTPATIENT_HOSPITAL" },
  { label: "23 - Emergency Room – Hospital", value: "EMERGENCY_ROOM_HOSPITAL" },
  {
    label: "24 - Ambulatory Surgical Center",
    value: "AMBULATORY_SURGICAL_CENTER",
  },
  { label: "25 - Birthing Center", value: "BIRTHING_CENTER" },
  {
    label: "26 - Military Treatment Facility",
    value: "MILITARY_TREATMENT_FACILITY",
  },
  { label: "31 - Skilled Nursing Facility", value: "SKILLED_NURSING_FACILITY" },
  { label: "32 - Nursing Facility", value: "NURSING_FACILITY" },
  { label: "33 - Custodial Care Facility", value: "CUSTODIAL_CARE_FACILITY" },
  { label: "34 - Hospice", value: "HOSPICE" },
  { label: "41 - Ambulance - Land", value: "AMBULANCE_LAND" },
  { label: "42 - Ambulance – Air or Water", value: "AMBULANCE_AIR_OR_WATER" },
  { label: "49 - Independent Clinic", value: "INDEPENDENT_CLINIC" },
  {
    label: "50 - Federally Qualified Health Center",
    value: "FEDERALLY_QUALIFIED_HEALTH_CENTER",
  },
  {
    label: "51 - Inpatient Psychiatric Facility",
    value: "INPATIENT_PSYCHIATRIC_FACILITY",
  },
  {
    label: "52 - Psychiatric Facility-Partial Hospitalization",
    value: "PSYCHIATRIC_FACILITY_PARTIAL_HOSPITALIZATION",
  },
  {
    label: "53 - Community Mental Health Center",
    value: "COMMUNITY_MENTAL_HEALTH_CENTER",
  },
  {
    label:
      "54 - Intermediate Care Facility/ Individuals with Intellectual Disabilities",
    value: "INTERMEDIATE_CARE_FACILITY_INTELLECTUAL_DISABILITIES",
  },
  {
    label: "55 - Residential Substance Abuse Treatment Facility",
    value: "RESIDENTIAL_SUBSTANCE_ABUSE_TREATMENT_FACILITY",
  },
  {
    label: "56 - Psychiatric Residential Treatment Center",
    value: "PSYCHIATRIC_RESIDENTIAL_TREATMENT_CENTER",
  },
  {
    label: "57 - Non-residential Substance Abuse Treatment Facility",
    value: "NON_RESIDENTIAL_SUBSTANCE_ABUSE_TREATMENT_FACILITY",
  },
  {
    label: "58 - Non-residential Opioid Treatment Facility",
    value: "NON_RESIDENTIAL_OPIOID_TREATMENT_FACILITY",
  },
  { label: "60 - Mass Immunization Center", value: "MASS_IMMUNIZATION_CENTER" },
  {
    label: "61 - Comprehensive Inpatient Rehabilitation Facility",
    value: "COMPREHENSIVE_INPATIENT_REHABILITATION_FACILITY",
  },
  {
    label: "62 - Comprehensive Outpatient Rehabilitation Facility",
    value: "COMPREHENSIVE_OUTPATIENT_REHABILITATION_FACILITY",
  },
  {
    label: "65 - End-Stage Renal Disease Treatment Facility",
    value: "END_STAGE_RENAL_DISEASE_TREATMENT_FACILITY",
  },
  { label: "71 - Public Health Clinic", value: "PUBLIC_HEALTH_CLINIC" },
  { label: "72 - Rural Health Clinic", value: "RURAL_HEALTH_CLINIC" },
  { label: "81 - Independent Laboratory", value: "INDEPENDENT_LABORATORY" },
  { label: "99 - Other Place of Service", value: "OTHER_PLACE_OF_SERVICE" },
];

export const PLACES_OF_SERVICE_MAPPER: Record<string, string> = {
  "01": "Pharmacy",
  "02": "Telehealth Provided Other than in Patient's Home",
  "03": "School",
  "04": "Homeless Shelter",
  "05": "Indian Health Service Free-standing Facility",
  "06": "Indian Health Service Provider-based Facility",
  "07": "Tribal 638 Free-standing Facility",
  "08": "Tribal 638 Provider-based Facility",
  "09": "Prison/Correctional Facility",
  "10": "Telehealth Provided in Patient's Home",
  "11": "Office",
  "12": "Home",
  "13": "Assisted Living Facility",
  "14": "Group Home",
  "15": "Mobile Unit",
  "16": "Temporary Lodging",
  "17": "Walk-in Retail Health Clinic",
  "18": "Place of Employment-Worksite",
  "19": "Off Campus-Outpatient Hospital",
  "20": "Urgent Care Facility",
  "21": "Inpatient Hospital",
  "22": "Outpatient Hospital",
  "23": "Emergency Room – Hospital",
  "24": "Ambulatory Surgical Center",
  "25": "Birthing Center",
  "26": "Military Treatment Facility",
  "31": "Skilled Nursing Facility",
  "32": "Nursing Facility",
  "33": "Custodial Care Facility",
  "34": "Hospice",
  "41": "Ambulance - Land",
  "42": "Ambulance – Air or Water",
  "49": "Independent Clinic",
  "50": "Federally Qualified Health Center",
  "51": "Inpatient Psychiatric Facility",
  "52": "Psychiatric Facility-Partial Hospitalization",
  "53": "Community Mental Health Center",
  "54": "Intermediate Care Facility/ Individuals with Intellectual Disabilities",
  "55": "Residential Substance Abuse Treatment Facility",
  "56": "Psychiatric Residential Treatment Center",
  "57": "Non-residential Substance Abuse Treatment Facility",
  "58": "Non-residential Opioid Treatment Facility",
  "60": "Mass Immunization Center",
  "61": "Comprehensive Inpatient Rehabilitation Facility",
  "62": "Comprehensive Outpatient Rehabilitation Facility",
  "65": "End-Stage Renal Disease Treatment Facility",
  "71": "Public Health Clinic",
  "72": "Rural Health Clinic",
  "81": "Independent Laboratory",
  "99": "Other Place of Service",
} as const;
